$(()=>{
 // $('.template-collection .product-item.hidden').remove();
     
      let posCollection = $('.collection__infinite-container').length ? $('.collection__infinite-container').offset().top : 100000;
      let posSitebar = $('.collection__sidebar').length ? $('.collection__sidebar').offset().top : 100000;
      
      $(window).scroll(function (event) {
            let scroll = $(this).scrollTop();
            
            if(scroll > posCollection){
              $('.arrow__up').addClass('active');
              
            }else{
              $('.arrow__up').removeClass('active');
            }
      });
    
  let imgsArray = [];
  function addImageUrl(){


    $('.url-icons span').each(function(){
      let nameIcon = $(this).attr('name-url-img').split('.')[0].toLowerCase();
      let url = $(this).attr('url-tag');
      $(this).attr('name', nameIcon);
      imgsArray.push('.filter-item__div-img[tag="'+nameIcon+'"]{background-image: url("'+url+'");}');

    });
   

    
    

    let css = imgsArray.join(''),
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

    head.appendChild(style);

    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));

  }

  addImageUrl();

  
  
$('.filter_btn').click(()=>{
  $('.filter_btn .plus-a').toggleClass('active');
  $('.filter__items').toggleClass('active');
  $('.collection-sidebar__heading ').addClass('closed');
  $('.group_item-btn ul[data-sort-by]').addClass('closed');
  if($('.collection-sidebar__group[data-group="Sort"]  ul[data-sort-by]').css('display')=='block'){
    $('.collection-sidebar__group[data-group="Sort"] .plus-a').toggleClass('active');
  }else{
   
  }
   setTimeout(function(){
     $('.group_item-btn ul[data-sort-by]').removeClass('closed');
     $('.group_item-btn ul[data-sort-by]').css('display','none ');
   },400);
});

$('.collection-sidebar__heading.closed').click(()=>{
 
  if($('.filter__items').hasClass('active')){
     $('.filter__items').removeClass('active');
     $('.filter_btn .plus-a').toggleClass('active');
  }
  $('.collection-sidebar__group[data-group="Sort"] .plus-a').toggleClass('active');
});

$('.collection__infinite-trigger a').click(function(){
  console.log($('.product-item').length);
  setTimeout(function(){
    console.log($('.product-item').length);
  },15000);
})
});